<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div [hidden]="isLoading" class="col-md-10 offset-md-1">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.backup.description' | escapeHtml"></div>
        <p>
          @if (!isHostedEnabled) {
            <span class="font-light" [innerHtml]="'tkey;admin.backup.body.description.text' | escapeHtml"></span>
          }
          @if (isHostedEnabled) {
            <span
              class="font-light"
              [innerHtml]="'tkey;admin.backup.hostedEnabled.body.description.text' | escapeHtml"
            ></span>
          }
        </p>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <div class="list-group list-group-striped border-rad-all-12 card-shadow">
      <div class="list-group-item">
        <h4>
          @if (!isHostedEnabled) {
            <span class="font-light" [innerHtml]="'tkey;admin.backup.daily.description.text' | escapeHtml"></span>
          }
          @if (isHostedEnabled) {
            <span
              class="font-light"
              [innerHtml]="'tkey;admin.backup.hostedEnabled.daily.description.text' | escapeHtml"
            ></span>
          }
        </h4>
        <ul>
          @for (fileName of dailyBackupFileNames; track fileName) {
            <li data-automation="admin-backup-daily-result-row">
              <a [href]="'/services/system/admin/backups/daily/' + fileName">
                <i [ngClass]="ziroIcons.DOWNLOAD"></i>
                {{ fileName }}
              </a>
            </li>
          }
        </ul>
      </div>

      <div class="list-group-item">
        <h4>
          @if (!isHostedEnabled) {
            <span class="font-light" [innerHtml]="'tkey;admin.backup.weekly.description.text' | escapeHtml"></span>
          }
          @if (isHostedEnabled) {
            <span
              class="font-light"
              [innerHtml]="'tkey;admin.backup.hostedEnabled.weekly.description.text' | escapeHtml"
            ></span>
          }
        </h4>
        <ul>
          @for (fileName of weeklyBackupFileNames; track fileName) {
            <li data-automation="admin-backup-weekly-result-row">
              <a [href]="'/services/system/admin/backups/weekly/' + fileName">
                <i [ngClass]="ziroIcons.DOWNLOAD"></i>
                {{ fileName }}
              </a>
            </li>
          }
        </ul>
      </div>

      <div class="list-group-item">
        <h4>{{ 'tkey;admin.backup.example.header' | translate }}</h4>
        <p [innerHtml]="'tkey;admin.backup.current.description' | escapeHtml"></p>
        <pre>curl -OJs -u $user:$password <a
        id="current-backup" [href]="'/services/system/admin/backups/current'"
        data-automation="admin-backup-current-backup-link"
      >{{ currentBackupUrl }}</a></pre>
      </div>
    </div>
  </div>
</div>
